export const getOriginalLocation = (): string => {
  let originalLocation = window.sessionStorage.getItem("originalLocation");
  const tempReferrer =
    window.sessionStorage.getItem("tempReferrer") ?? "noreferrer";
  const currentUrl = window.location.href;
  const { referrer = null } = document;

  let isExternalReferrer = true;

  if (originalLocation) isExternalReferrer = false;

  if (referrer?.startsWith("http") && referrer !== tempReferrer) {
    const url = new URL(referrer);
    const { hostname } = url;
    isExternalReferrer = hostname.search("beautypie") === -1;
  }
  if (referrer === "" && referrer !== tempReferrer) isExternalReferrer = true;

  if (isExternalReferrer) {
    window.sessionStorage.setItem("originalLocation", currentUrl);
    window.sessionStorage.setItem("tempReferrer", referrer ?? "noreferrer");
  }

  originalLocation = window.sessionStorage.getItem("originalLocation");
  if (originalLocation) return originalLocation;
  return currentUrl;
};
